module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_8.9db94c85.png";